/**
 * 도메인 코드값. DB는 text 컬럼으로 저장하고(pg enum 미사용) 여기 상수로 타입을 좁힌다.
 * 값 목록의 출처는 docs/SCHEMA.md — 변경 시 문서도 같이 고친다.
 */
export const USER_ROLES = ['member', 'admin'];
/**
 * 탭 표시 순서 = 이 배열 순서. 메인은 장터라 맨 앞에 둔다.
 * book = 책 전용 거래 게시판(책방). notice = 관리자만 쓰는 공지판(알립니다), 맨 오른쪽.
 * notice 외 나머지는 전원 작성 가능.
 */
export const BOARD_SLUGS = ['market', 'book', 'talk', 'notice'];
/**
 * 거래형 게시판(거래유형·가격·상태·끌올·찜·대화가 붙는 곳)과 게시판별 거래유형.
 * 책방은 돈 받고 팔거나 책끼리 바꾸는 곳이라 나눔 대신 교환을 둔다.
 */
export const MARKET_BOARDS = ['market', 'book'];
export function isMarketBoard(slug) {
    return MARKET_BOARDS.includes(slug);
}
/** talk 게시판 카테고리 */
export const TALK_CATEGORIES = ['daily', 'info', 'groupbuy', 'hobby', 'ask'];
/**
 * 거래형 게시판 거래유형 전체 목록(검증·라벨용).
 * 구하는 쪽 유형(삽니다·빌려주세요)은 2026.9 폐지 — 내놓는 글만 남긴다.
 * 게시판별로 고를 수 있는 유형은 BOARD_TRADE_TYPES가 정한다.
 */
export const TRADE_TYPES = ['sell', 'free', 'exchange'];
/** 게시판별 거래유형. 작성 폼 옵션과 서버 검증이 둘 다 이 목록을 쓴다. */
export const BOARD_TRADE_TYPES = {
    market: ['sell', 'free'],
    book: ['sell', 'exchange'],
};
/** market 게시판 거래상태 */
export const TRADE_STATUSES = ['selling', 'reserved', 'sold'];
/** 계열사 코드. null = 미설정 */
export const AFFILIATIONS = [
    'innovation',
    'financial',
    'healthcare',
    'hecto',
    'data',
    'media',
    'qnm',
    'walletone',
    'etc',
];
export const BOARD_LABELS = {
    notice: '알립니다',
    market: '장터',
    book: '책방',
    talk: '수다·정보',
};
export const TALK_CATEGORY_LABELS = {
    daily: '일상',
    info: '정보',
    groupbuy: '같이 사요',
    hobby: '취미',
    ask: '질문',
};
export const TRADE_TYPE_LABELS = {
    sell: '팝니다',
    free: '나눔',
    exchange: '교환',
};
/** 거래 상태 문구. */
export function tradeStatusLabel(status, tradeType) {
    if (!status)
        return '';
    if (status === 'reserved')
        return '예약중';
    if (status === 'sold')
        return '완료';
    if (tradeType === 'free')
        return '나눔중';
    if (tradeType === 'exchange')
        return '교환중';
    return '판매중';
}
/**
 * 거래 장소. 주관식이면 "1층 로비 앞", "틔움에서요" 처럼 표기가 갈려
 * 나중에 필터·통계를 못 낸다. 사내 거점이 몇 개뿐이라 고정 옵션으로 둔다.
 */
export const TRADE_PLACES = ['taekwang_tium', 'keungil_tium', 'taekwang_1f', 'keungil_1f'];
export const TRADE_PLACE_LABELS = {
    taekwang_tium: '태광 틔움',
    keungil_tium: '큰길 틔움',
    taekwang_1f: '태광 1층',
    keungil_1f: '큰길 1층',
};
/** 목록 정렬 */
export const POST_SORTS = ['active', 'new', 'popular'];
export const POST_SORT_LABELS = {
    active: '활발',
    new: '새글',
    popular: '인기',
};
export const AFFILIATION_LABELS = {
    innovation: '헥토이노베이션',
    financial: '헥토파이낸셜',
    healthcare: '헥토헬스케어',
    hecto: '(주)헥토',
    data: '헥토데이터',
    media: '헥토미디어',
    qnm: '헥토큐앤엠',
    walletone: '헥토월렛원',
    etc: '기타',
};
//# sourceMappingURL=enums.js.map